"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _Register = require("../Screens/User/Register");

var _Register2 = _interopRequireDefault(_Register);

var _Login = require("../Screens/User/Login");

var _Login2 = _interopRequireDefault(_Login);

var _OTP = require("../Screens/User/OTP");

var _OTP2 = _interopRequireDefault(_OTP);

var _common = require("modules/common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// user routes
var Loading = function Loading() {
  return _react2.default.createElement("div", null);
};

// pgr citizen specific screens
var MyComplaints = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MyComplaints");
  },
  loading: Loading
});
var ComplaintDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ComplaintDetails");
  },
  loading: Loading
});
var ComplaintCreated = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/ComplaintCreated");
  },
  loading: Loading
});
var Feedback = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/Feedback");
  },
  loading: Loading
});
var PGRHome = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/Home");
  },
  loading: Loading
});
var AddComplaint = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/AddComplaint");
  },
  loading: Loading
});
var FeedbackAcknowledge = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/FeedbackAcknowledgement");
  },
  loading: Loading
});

var routes = [{
  path: "user/register",
  component: _Register2.default,
  needsAuthentication: false,
  redirectionUrl: "/"
}, {
  path: "user/login",
  component: _Login2.default,
  needsAuthentication: false,
  redirectionUrl: "/"
}, {
  path: "user/otp",
  component: _OTP2.default,
  needsAuthentication: false,
  redirectionUrl: "/"
}, {
  path: "my-complaints",
  component: MyComplaints,
  needsAuthentication: true,
  options: {
    //title: "CS_HOME_MY_COMPLAINTS"
    title: "My Complaints"
  }
}, {
  path: "complaint-details/:serviceRequestId?",
  component: ComplaintDetails,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    //  title: "CS_HEADER_COMPLAINT_SUMMARY"
    title: "Complaint Summary"
  }
}, {
  path: "complaint-submitted",
  component: ComplaintCreated,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    //title: "CS_HEADER_COMPLAINT_SUBMITTED",
    title: "Complaint Filed",
    hideTitle: true,
    hideBackButton: true
  }
}, {
  path: "feedback/:serviceRequestId?",
  component: Feedback,
  needsAuthentication: true,
  options: {
    //title: "CS_HEADER_FEEDBACK",
    title: "Feedback",
    titleBackground: true // Use this if you need white background for title in web version
  }
}, {
  path: "feedback-acknowledgement",
  component: FeedbackAcknowledge,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    hideBackButton: true,
    // title: "CS_HEADER_FEEDBACK_ACKNOWLEDGEMENT",
    title: "Feddback Submitted",
    hideTitle: true
  }
}, {
  path: "add-complaint",
  component: AddComplaint,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "Complaint Submission"
  }
}, {
  path: "pgr/pgr-home",
  component: PGRHome,
  needsAuthentication: true,
  options: {
    // isHomeScreen: true,
    title: "Complaints",
    hideTitle: true,
    redirectionUrl: "/user/register",
    helpButton: true
  }
}, {
  path: "reopen-complaint/:serviceRequestId?",
  component: _common.ReOpenComplaint,
  needsAuthentication: true,
  options: {
    title: "Reopen Complaint",
    titleBackground: true // Use this if you need white background for title in web version
  }
}, {
  path: "reopen-acknowledgement",
  component: _common.ReopenAcknowledgement,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    hideBackButton: true,
    title: "Complaint Re-opened",
    hideTitle: true
  }
}, {
  path: "complaint-type",
  component: _common.ComplaintType,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "Complaint Type",
    hideTitle: true
  }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-grievance/Routes/pgr-routes.js
// module id = 3504
// module chunks = 1137